import React from 'react';
import VideoItem from '../../shared/components/VideoItem';
import { StyleSheet, css } from 'aphrodite/no-important';
import { widthRange } from '../../shared/constants';
import { media } from '../../shared/styles/constants';
import {constants} from '../constants';

const cssMediaItemSettingsLeft = {
	desktop: { item: { width: '100%' }},
	laptop: { item: { width: '100%' }},
	tablet: { item: { width: '100%' }},
	mobile: {
		item: { width: '100%' },
		itemMeta: {
			marginLeft: '10px',
			marginRight: '10px'
		}
	}
};

const cssMediaItemSettingsRight = {
	desktop: { item: { width: '260px' }},
	laptop: { item: { width: '100%' }},
	tablet: { item: { width: '100%' }},
	mobile: { item: { width: '46%' }}
};

class FiveItems extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			leftContainerPosts: this.props.posts.slice(0, 1),
			rightContainerPosts: this.props.posts.slice(1, 5),
			currentWidthRange: widthRange.DESKTOP_MOBILE
		}
	}

	organizeContainers(){
		if (!window) {
			return;
		}

		let width = window.innerWidth;

		if (width >= 1280 || width <= 767) {
			if (this.state.currentWidthRange === widthRange.DESKTOP_MOBILE) {
				return;
			}

			this.setState(() => ({
				leftContainerPosts: this.props.posts.slice(0, 1),
				rightContainerPosts: this.props.posts.slice(1, 5),
				currentWidthRange: widthRange.DESKTOP_MOBILE
			}));

			return;
		}

		if (this.state.currentWidthRange === widthRange.tabletLaptop) {
			return;
		}

		this.setState(() => ({
			leftContainerPosts: this.props.posts.slice(0, 2),
			rightContainerPosts: this.props.posts.slice(2, 5),
			currentWidthRange: widthRange.tabletLaptop
		}));
	}

	componentDidMount() {
		this.organizeContainers();

		if (window){
			window.addEventListener("resize", this.organizeContainers.bind(this));
		}
	}

	componentWillUnmount() {
		if (window){
			window.removeEventListener("resize", this.organizeContainers.bind(this));
		}
	}

	render() {
		const leftPosts = this.state.leftContainerPosts;
		const rightPosts = this.state.rightContainerPosts;
		let leftIdx = 0;
		let rightIdx = 0;
		let outerIndex = 0;
		let utmObj = this.props.utmObj || {};
		let key = 1;

		return (
			<div className={css(this.props.containerStyle)}>
				<div className={css(styles.leftContainer)}>
					{leftPosts.map(p => (
						<VideoItem post={p} key={key++} mediaSettings={cssMediaItemSettingsLeft} innerIndex={leftIdx++} outerIndex={outerIndex++} utmObj={utmObj} classPostfix={constants.VC_CLASS_POSTFIX} />
					))}
				</div>
				<div className={css(styles.rightContainer)}>
					{rightPosts.map(p => (
						<VideoItem post={p} key={key++} mediaSettings={cssMediaItemSettingsRight} innerIndex={rightIdx++} outerIndex={outerIndex++} utmObj={utmObj} classPostfix={constants.VC_CLASS_POSTFIX} />
					))}
				</div>
			</div>
		);
	}
}

export default FiveItems;

const styles = StyleSheet.create({
	leftContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		width: '560px',

		[media.LAPTOP]: {
			width: '560px'
		},

		[media.TABLET]: {
			width: '450px'
		},

		[media.MOBILE]: {
			width: '100%',
			justifyContent: 'space-around'
		}
	},
	rightContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		width: '560px',

		[media.LAPTOP]: {
			width: '360px'
		},

		[media.TABLET]: {
			width: '223px'
		},

		[media.MOBILE]: {
			width: '100%',
			justifyContent: 'space-around'
		}
	}
});



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/components/FiveItems.js